import { FC } from 'react';
import slugify from 'slugify';
import { buttonClick } from '@belong/analytics';
import { useAnalyticsEvents } from '@belong/providers/analyticsEvents';
import { INavLinksSocial } from '@belong/types';
import { SocialLink, StyledIcon } from './NavLinksSocial.styles';

export const NavLinksSocial: FC<INavLinksSocial> = ({ label, socialIcon, ...linkProps }: INavLinksSocial) => {
  const analyticsEvents = useAnalyticsEvents();

  const handleClick = () => {
    analyticsEvents.send(
      buttonClick({
        label: slugify(label, { replacement: '-', remove: /_&\+!#\*/, lower: true }).trim(),
        text: label,
        otherProps: { component: 'footer' }
      })
    );
  };

  return (
    <SocialLink {...linkProps} onClick={handleClick} aria-label={label}>
      <StyledIcon name={socialIcon} size="smallplus" />
    </SocialLink>
  );
};

NavLinksSocial.displayName = 'NavLinksSocial';
export default NavLinksSocial;
